export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شروط الاستخدام"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعلان حماية البيانات"])}
        }
      },
      "ar-DZ": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شروط الاستخدام"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعلان حماية البيانات"])}
        }
      },
      "ar-EG": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شروط الاستخدام"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعلان حماية البيانات"])}
        }
      },
      "ar-LB": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شروط الاستخدام"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعلان حماية البيانات"])}
        }
      },
      "ar-MA": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شروط الاستخدام"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعلان حماية البيانات"])}
        }
      },
      "ar-SA": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعليمات الاستخدام"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعلان حماية البيانات"])}
        }
      },
      "ar-SY": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شروط الاستخدام"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعلان حماية البيانات"])}
        }
      },
      "ar-TN": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شروط الاستخدام"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعلان حماية البيانات"])}
        }
      },
      "bg-BG": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Условия за ползване"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Декларация за защита на данните"])}
        }
      },
      "bs-BA": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pravila korištenja"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izjava o zaštiti podataka"])}
        }
      },
      "cs-CZ": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podmínky použití"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prohlášení o ochraně údajů"])}
        }
      },
      "da-DK": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Betingelser for brug"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Databeskyttelseserklæring"])}
        }
      },
      "de-DE": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutzungsbedingungen"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutzerklärung"])}
        }
      },
      "de-AT": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutzungsbedingungen"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutzerklärung"])}
        }
      },
      "de-CH": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutzungsbedingungen"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutzerklärung"])}
        }
      },
      "de-LU": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutzungsbedingungen"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutzerklärung"])}
        }
      },
      "el-GR": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οροι χρήσης"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δήλωση προστασίας δεδομένων"])}
        }
      },
      "el-CY": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οροι χρήσης"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δήλωση προστασίας δεδομένων"])}
        }
      },
      "en-GB": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terms of Use"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data Protection Declaration"])}
        }
      },
      "en-IE": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terms of Use"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data Protection Declaration"])}
        }
      },
      "en-US": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terms of Use"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data Protection Declaration"])}
        }
      },
      "es-ES": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Términos de Uso"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Declaración de protección de datos"])}
        }
      },
      "et-EE": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kasutustingimused"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Andmekaitsedeklaratsioon"])}
        }
      },
      "fi-FI": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käyttöehdot"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tietosuojailmoitus"])}
        }
      },
      "fr-BE": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conditions d’utilisation"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déclaration de protection des données"])}
        }
      },
      "fr-CH": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conditions d’utilisation"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déclaration de protection des données"])}
        }
      },
      "fr-FR": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conditions d’utilisation"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déclaration de protection des données"])}
        }
      },
      "fr-LU": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conditions d’utilisation"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déclaration de protection des données"])}
        }
      },
      "ga-IE": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Téarmaí Úsáide"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dearbhú cosanta sonraí"])}
        }
      },
      "he-IL": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["תנאי שימוש"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הצהרת הגנת נתונים"])}
        }
      },
      "hi-IN": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["उपयोग की शर्तें"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["डाटा सुरक्षा घोषणा"])}
        }
      },
      "hr-HR": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uvjeti korištenja"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izjava o zaštiti podataka"])}
        }
      },
      "hu-HU": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Használati feltételek"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adatvédelmi nyilatkozat"])}
        }
      },
      "it-CH": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Termini di utilizzo"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dichiarazione sulla protezione dei dati"])}
        }
      },
      "it-IT": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Condizioni d'uso"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dichiarazione sulla protezione dei dati"])}
        }
      },
      "ja-JP": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["利用規約"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["データ保護宣言"])}
        }
      },
      "ko-KR": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["이용 약관"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["데이터 보호 선언"])}
        }
      },
      "lt-LT": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naudojimo sąlygos"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duomenų apsaugos deklaracija"])}
        }
      },
      "lv-LV": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lietošanas noteikumi"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datu aizsardzības deklarācija"])}
        }
      },
      "mt-MT": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Termini ta'Użu"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dikjarazzjoni ta' Protezzjoni tad-Data"])}
        }
      },
      "nb-NO": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bruksvilkår"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deklarasjon om databeskyttelse"])}
        }
      },
      "nl-BE": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruiksvoorwaarden"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verklaring gegevensbescherming"])}
        }
      },
      "nl-NL": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruiksvoorwaarden"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verklaring gegevensbescherming"])}
        }
      },
      "pl-PL": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Warunki korzystania"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oświadczenie o ochronie danych"])}
        }
      },
      "pt-PT": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Termos de uso"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Declaração de proteção de dados"])}
        }
      },
      "ro-RO": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Termeni de utilizare"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Declarație privind protecția datelor"])}
        }
      },
      "ru-RU": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Условия эксплуатации"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Заявление о защите данных"])}
        }
      },
      "sk-SK": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podmienky používania"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhlásenie o ochrane údajov"])}
        }
      },
      "sl-SI": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogoji uporabe"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izjava o varstvu podatkov"])}
        }
      },
      "sv-SE": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Villkor"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dataskyddsdeklaration"])}
        }
      },
      "th-TH": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["เงื่อนไขการใช้งาน"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ประกาศการป้องกันข้อมูล"])}
        }
      },
      "tr-CY": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanım Şartları"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veri koruma beyanı"])}
        }
      },
      "tr-TR": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanım Şartları"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veri koruma beyanı"])}
        }
      },
      "uk-UA": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Умови користування"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Декларація захисту даних"])}
        }
      },
      "vi-VN": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Điều khoản sử dụng"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tuyên bố bảo vệ dữ liệu"])}
        }
      },
      "zh-CN": {
        "termsOfUse": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用条款"])}
        },
        "privacyPolicy": {
          "linkLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据保护声明"])}
        }
      }
    }
  })
}
